/**
 * @fileoverview gRPC-Web generated client stub for cloud
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var job_pb = require('./job_pb.js')

var manifest_pb = require('./manifest_pb.js')

var entity_pb = require('./entity_pb.js')

var general_pb = require('./general_pb.js')

var query_pb = require('./query_pb.js')

var comments_pb = require('./comments_pb.js')
const proto = {};
proto.cloud = require('./service_query_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceQueryInternalClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceQueryInternalPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.EmailValidRequest,
 *   !proto.cloud.EmailValidResponse>}
 */
const methodDescriptor_ServiceQueryInternal_AreEmailsValid = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryInternal/AreEmailsValid',
  grpc.web.MethodType.UNARY,
  proto.cloud.EmailValidRequest,
  proto.cloud.EmailValidResponse,
  /**
   * @param {!proto.cloud.EmailValidRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EmailValidResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.EmailValidRequest,
 *   !proto.cloud.EmailValidResponse>}
 */
const methodInfo_ServiceQueryInternal_AreEmailsValid = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.EmailValidResponse,
  /**
   * @param {!proto.cloud.EmailValidRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EmailValidResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.EmailValidRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.EmailValidResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.EmailValidResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryInternalClient.prototype.areEmailsValid =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryInternal/AreEmailsValid',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryInternal_AreEmailsValid,
      callback);
};


/**
 * @param {!proto.cloud.EmailValidRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.EmailValidResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryInternalPromiseClient.prototype.areEmailsValid =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryInternal/AreEmailsValid',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryInternal_AreEmailsValid);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.UserMigrationDataRequest,
 *   !proto.cloud.UserMigrationDataResponse>}
 */
const methodDescriptor_ServiceQueryInternal_RetreiveUserMigrationData = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryInternal/RetreiveUserMigrationData',
  grpc.web.MethodType.UNARY,
  proto.cloud.UserMigrationDataRequest,
  proto.cloud.UserMigrationDataResponse,
  /**
   * @param {!proto.cloud.UserMigrationDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserMigrationDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.UserMigrationDataRequest,
 *   !proto.cloud.UserMigrationDataResponse>}
 */
const methodInfo_ServiceQueryInternal_RetreiveUserMigrationData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.UserMigrationDataResponse,
  /**
   * @param {!proto.cloud.UserMigrationDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserMigrationDataResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.UserMigrationDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.UserMigrationDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.UserMigrationDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryInternalClient.prototype.retreiveUserMigrationData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryInternal/RetreiveUserMigrationData',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryInternal_RetreiveUserMigrationData,
      callback);
};


/**
 * @param {!proto.cloud.UserMigrationDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.UserMigrationDataResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryInternalPromiseClient.prototype.retreiveUserMigrationData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryInternal/RetreiveUserMigrationData',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryInternal_RetreiveUserMigrationData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.AccountBillingDataRequest,
 *   !proto.cloud.AccountBillingDataResponse>}
 */
const methodDescriptor_ServiceQueryInternal_RetrieveAccountBillingData = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryInternal/RetrieveAccountBillingData',
  grpc.web.MethodType.UNARY,
  proto.cloud.AccountBillingDataRequest,
  proto.cloud.AccountBillingDataResponse,
  /**
   * @param {!proto.cloud.AccountBillingDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountBillingDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.AccountBillingDataRequest,
 *   !proto.cloud.AccountBillingDataResponse>}
 */
const methodInfo_ServiceQueryInternal_RetrieveAccountBillingData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.AccountBillingDataResponse,
  /**
   * @param {!proto.cloud.AccountBillingDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountBillingDataResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.AccountBillingDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.AccountBillingDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.AccountBillingDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryInternalClient.prototype.retrieveAccountBillingData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryInternal/RetrieveAccountBillingData',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryInternal_RetrieveAccountBillingData,
      callback);
};


/**
 * @param {!proto.cloud.AccountBillingDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.AccountBillingDataResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryInternalPromiseClient.prototype.retrieveAccountBillingData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryInternal/RetrieveAccountBillingData',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryInternal_RetrieveAccountBillingData);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceQueryProjectClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceQueryProjectPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.JobListRequest,
 *   !proto.cloud.JobListResponse>}
 */
const methodDescriptor_ServiceQueryProject_ListJobs = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryProject/ListJobs',
  grpc.web.MethodType.UNARY,
  proto.cloud.JobListRequest,
  proto.cloud.JobListResponse,
  /**
   * @param {!proto.cloud.JobListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobListResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.JobListRequest,
 *   !proto.cloud.JobListResponse>}
 */
const methodInfo_ServiceQueryProject_ListJobs = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.JobListResponse,
  /**
   * @param {!proto.cloud.JobListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobListResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.JobListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.JobListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.JobListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryProjectClient.prototype.listJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListJobs',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListJobs,
      callback);
};


/**
 * @param {!proto.cloud.JobListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.JobListResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryProjectPromiseClient.prototype.listJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListJobs',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListJobs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.JobGetRequest,
 *   !proto.cloud.JobGetResponse>}
 */
const methodDescriptor_ServiceQueryProject_GetJobs = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryProject/GetJobs',
  grpc.web.MethodType.UNARY,
  proto.cloud.JobGetRequest,
  proto.cloud.JobGetResponse,
  /**
   * @param {!proto.cloud.JobGetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobGetResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.JobGetRequest,
 *   !proto.cloud.JobGetResponse>}
 */
const methodInfo_ServiceQueryProject_GetJobs = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.JobGetResponse,
  /**
   * @param {!proto.cloud.JobGetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobGetResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.JobGetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.JobGetResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.JobGetResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryProjectClient.prototype.getJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryProject/GetJobs',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_GetJobs,
      callback);
};


/**
 * @param {!proto.cloud.JobGetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.JobGetResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryProjectPromiseClient.prototype.getJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryProject/GetJobs',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_GetJobs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.EntityListRequest,
 *   !proto.cloud.EntityListResponse>}
 */
const methodDescriptor_ServiceQueryProject_ListEntities = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryProject/ListEntities',
  grpc.web.MethodType.UNARY,
  proto.cloud.EntityListRequest,
  proto.cloud.EntityListResponse,
  /**
   * @param {!proto.cloud.EntityListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EntityListResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.EntityListRequest,
 *   !proto.cloud.EntityListResponse>}
 */
const methodInfo_ServiceQueryProject_ListEntities = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.EntityListResponse,
  /**
   * @param {!proto.cloud.EntityListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EntityListResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.EntityListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.EntityListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.EntityListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryProjectClient.prototype.listEntities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListEntities',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListEntities,
      callback);
};


/**
 * @param {!proto.cloud.EntityListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.EntityListResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryProjectPromiseClient.prototype.listEntities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListEntities',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListEntities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.EntityGetRequest,
 *   !proto.cloud.EntityGetResponse>}
 */
const methodDescriptor_ServiceQueryProject_GetEntities = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryProject/GetEntities',
  grpc.web.MethodType.UNARY,
  proto.cloud.EntityGetRequest,
  proto.cloud.EntityGetResponse,
  /**
   * @param {!proto.cloud.EntityGetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EntityGetResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.EntityGetRequest,
 *   !proto.cloud.EntityGetResponse>}
 */
const methodInfo_ServiceQueryProject_GetEntities = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.EntityGetResponse,
  /**
   * @param {!proto.cloud.EntityGetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EntityGetResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.EntityGetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.EntityGetResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.EntityGetResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryProjectClient.prototype.getEntities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryProject/GetEntities',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_GetEntities,
      callback);
};


/**
 * @param {!proto.cloud.EntityGetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.EntityGetResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryProjectPromiseClient.prototype.getEntities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryProject/GetEntities',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_GetEntities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.CurrentStorageIdRequest,
 *   !proto.cloud.CurrentStorageIdResponse>}
 */
const methodDescriptor_ServiceQueryProject_GetCurrentStorageId = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryProject/GetCurrentStorageId',
  grpc.web.MethodType.UNARY,
  proto.cloud.CurrentStorageIdRequest,
  proto.cloud.CurrentStorageIdResponse,
  /**
   * @param {!proto.cloud.CurrentStorageIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CurrentStorageIdResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.CurrentStorageIdRequest,
 *   !proto.cloud.CurrentStorageIdResponse>}
 */
const methodInfo_ServiceQueryProject_GetCurrentStorageId = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.CurrentStorageIdResponse,
  /**
   * @param {!proto.cloud.CurrentStorageIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CurrentStorageIdResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.CurrentStorageIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.CurrentStorageIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.CurrentStorageIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryProjectClient.prototype.getCurrentStorageId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryProject/GetCurrentStorageId',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_GetCurrentStorageId,
      callback);
};


/**
 * @param {!proto.cloud.CurrentStorageIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.CurrentStorageIdResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryProjectPromiseClient.prototype.getCurrentStorageId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryProject/GetCurrentStorageId',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_GetCurrentStorageId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.TagListRequest,
 *   !proto.cloud.TagListResponse>}
 */
const methodDescriptor_ServiceQueryProject_ListTags = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryProject/ListTags',
  grpc.web.MethodType.UNARY,
  proto.cloud.TagListRequest,
  proto.cloud.TagListResponse,
  /**
   * @param {!proto.cloud.TagListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.TagListResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.TagListRequest,
 *   !proto.cloud.TagListResponse>}
 */
const methodInfo_ServiceQueryProject_ListTags = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.TagListResponse,
  /**
   * @param {!proto.cloud.TagListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.TagListResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.TagListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.TagListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.TagListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryProjectClient.prototype.listTags =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListTags',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListTags,
      callback);
};


/**
 * @param {!proto.cloud.TagListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.TagListResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryProjectPromiseClient.prototype.listTags =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListTags',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListTags);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.CommentListRequest,
 *   !proto.cloud.CommentListResponse>}
 */
const methodDescriptor_ServiceQueryProject_ListComments = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryProject/ListComments',
  grpc.web.MethodType.UNARY,
  proto.cloud.CommentListRequest,
  proto.cloud.CommentListResponse,
  /**
   * @param {!proto.cloud.CommentListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CommentListResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.CommentListRequest,
 *   !proto.cloud.CommentListResponse>}
 */
const methodInfo_ServiceQueryProject_ListComments = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.CommentListResponse,
  /**
   * @param {!proto.cloud.CommentListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CommentListResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.CommentListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.CommentListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.CommentListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryProjectClient.prototype.listComments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListComments',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListComments,
      callback);
};


/**
 * @param {!proto.cloud.CommentListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.CommentListResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryProjectPromiseClient.prototype.listComments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListComments',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListComments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.ListManifestsRequest,
 *   !proto.cloud.ListManifestsResponse>}
 */
const methodDescriptor_ServiceQueryProject_ListManifests = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryProject/ListManifests',
  grpc.web.MethodType.UNARY,
  proto.cloud.ListManifestsRequest,
  proto.cloud.ListManifestsResponse,
  /**
   * @param {!proto.cloud.ListManifestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ListManifestsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.ListManifestsRequest,
 *   !proto.cloud.ListManifestsResponse>}
 */
const methodInfo_ServiceQueryProject_ListManifests = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.ListManifestsResponse,
  /**
   * @param {!proto.cloud.ListManifestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ListManifestsResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.ListManifestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.ListManifestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.ListManifestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryProjectClient.prototype.listManifests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListManifests',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListManifests,
      callback);
};


/**
 * @param {!proto.cloud.ListManifestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.ListManifestsResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryProjectPromiseClient.prototype.listManifests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryProject/ListManifests',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_ListManifests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.GetManifestsRequest,
 *   !proto.cloud.GetManifestsResponse>}
 */
const methodDescriptor_ServiceQueryProject_GetManifests = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryProject/GetManifests',
  grpc.web.MethodType.UNARY,
  proto.cloud.GetManifestsRequest,
  proto.cloud.GetManifestsResponse,
  /**
   * @param {!proto.cloud.GetManifestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.GetManifestsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.GetManifestsRequest,
 *   !proto.cloud.GetManifestsResponse>}
 */
const methodInfo_ServiceQueryProject_GetManifests = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.GetManifestsResponse,
  /**
   * @param {!proto.cloud.GetManifestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.GetManifestsResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.GetManifestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.GetManifestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.GetManifestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryProjectClient.prototype.getManifests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryProject/GetManifests',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_GetManifests,
      callback);
};


/**
 * @param {!proto.cloud.GetManifestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.GetManifestsResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryProjectPromiseClient.prototype.getManifests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryProject/GetManifests',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryProject_GetManifests);
};


module.exports = proto.cloud;

